



















import {Vue, Component, Prop} from 'vue-property-decorator';
import bookingDefault from '@/instance-defaults/bookingDefault';
import {BOOKING_STATUS, CALENDAR_FORMAT, CLAIM_STATUS, multiNil, nil} from '@/common';
import {Mixins} from 'vue-property-decorator';
import BookingGoogleMapsMixin from '@/mixins/BookingGoogleMapsMixin.vue';
import VendorBox from '@/components/Views/Vendor/VendorBox.vue';
import vendorDefault from '@/instance-defaults/vendorDefault';
import ScreenSizeMixin from '@/mixins/ScreenSizeMixin.vue';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import {DateTime} from 'luxon';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import BookingCard from '@/components/Views/Dashboard/Booking/BookingCard.vue';
@Component({
    components: {
        BookingCard,
        VendorBox,
    },
})
export default class AdminBookingCard extends Vue {
    @Prop({default: bookingDefault})
    public booking!: any;

    public async onBook(vendor) {
        if (!nil(this.booking)) {
            const {VendorClaim, Booking} = this.$FeathersVuex;
            // this.booking.assignedVendor = vendor._id;
            const claim = await VendorClaim.find({query: {booking: this.booking._id, vendor: vendor._id}});
            claim.status = CLAIM_STATUS.ASSIGNED;
            await claim.save();
            const b = await Booking.get(this.booking._id);
            this.showAlert('This pro will get an email notifying them of their assignment', 'success');
            this.$emit('onBookingUpdated', b);
        }
    }


    public get bookingId() {
        if (multiNil(this, 'booking._id')) { return ''; }
        return this.booking._id;
    }

    public get noAssignedVendor() {
        return multiNil(this, 'booking.assignedVendor');
    }
    public get noRequestedVendor() {
        return multiNil(this, 'booking.requestedVendor');
    }
    public get requestedVendor() {
        if (this.noRequestedVendor) { return vendorDefault; }
        return this.booking.requestedVendorModel;
    }
    public get assignedVendor() {
        if (this.noAssignedVendor) { return vendorDefault; }
        return this.booking.assignedVendorModel;
    }
    public get canResendEmails() {
        if (nil(this.booking)) { return false; }
        return this.booking.status === BOOKING_STATUS.WAITING_ON_ANY_PRO;
    }
}
